module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("CONTENTS"), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "subchapter"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312316433_L02.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_frw_r1.htm"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c01_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c02_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c03_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c04_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STEPHEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c05_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c06_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RICHARD I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c07_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c08_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY III")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c09_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c10_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c11_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD III")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c12_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RICHARD II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c13_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c14_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY V")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c15_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c16_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c17_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RICHARD III")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c18_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY VII")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c19_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY VIII")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c20_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c21_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARY I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c22_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ELIZABETH I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c23_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JAMES I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c24_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHARLES I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c25_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHARLES II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c26_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JAMES II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c27_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM III AND MARY II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c28_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANNE")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c29_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c30_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c31_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE III")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c32_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c33_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c34_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("VICTORIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c35_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD VII")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c36_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE V")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c37_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD VIII")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c38_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GEORGE VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_c39_r1.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ELIZABETH II")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780312316433_epub_ind_r1.htm"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca055fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312316433_epub_toc_r1.vue
// module id = 72
// module chunks = 0